var process = require("../shim/process.js");
const config = require("../config.js");
const TERRAIN = require("../libs/Terrain.js");
const v = require("../libs/Zone.js");
const weapons = require("./weapons.js");
const store = require("./store.js");
const triggers = require("./triggers.js");
const modes = require("./modes.js");
var prefabs = new (require("./prefabs.js"))(config);
const GameObject = require("./objects.js").GameObject;
if (config.isNode) {
  const fs = require("fs");
  const path = require("path");
  fs.readFileSync(path.join(process.cwd(), "apikey.txt"), "utf8");
}
var rotationModes = [0, 1, 2, 3, 19];

for (
  var maps = [
      require("../../maps/burg.json"),
      require("../../maps/littletown.json"),
      require("../../maps/sandstorm.json"),
      require("../../maps/subzero.json"),
      require("../../maps/undergrowth.json"),
      require("../../maps/shipyard.json"),
      require("../../maps/freight.json"),
      require("../../maps/lostworld.json"),
      require("../../maps/citadel.json"),
      require("../../maps/oasis.json"),
      require("../../maps/kanji.json"),
      require("../../maps/newtown.json"),
      require("../../maps/industry.json"),
      require("../../maps/soul_sanctum.json"),
      require("../../maps/evacuation.json"),
    ],
    G = 0;
  G < maps.length;
  ++G
) {
  for (var H = 0; H < maps[G].objects.length; ++H) {
    maps[G].objects[H].i =
      prefabs.prefabs[maps[G].objects[H].i || maps[G].objects[H].id || 0].name;
    maps[G].objects[H].t =
      prefabs.textures[
        maps[G].objects[H].t || (maps[G].objects[H].i == "LADDER" ? 2 : 0)
      ].name;
  }
}
function I(M, N) {
  if (Array.isArray(N)) {
    return N.map((Q) => I(M, Q));
  }
  if (typeof N == "object") {
    var O = {};
    for (var P in N) {
      O[P] = I(M, N[P]);
    }
    return O;
  }
  return M.gameObjects[N];
}
function mapGenID(M, N) {
  return M + (N.genID == null ? "" : "_" + N.genID);
}
// window.world = a.exports;
module.exports.maps = maps;
module.exports.manager = function (RENDER, PARTICLES, UTILS, SOUND, config) {
  var OBJECT;
  var U;
  this.manager = new (require("./objects.js").manager)(
    RENDER,
    UTILS,
    SOUND,
    prefabs,
    config,
  );
  this.maps = maps;
  this.modes = modes;
  this.rotationModes = rotationModes;
  this.rotationMaps = [0, 1, 2, 3, 4, 6, 7, 8, 9, 10, 11, 12, 14];
  this.spawns = [];
  this.lastGen = null;
  this.terrain = null;
  this.zone = null;
  this.billboard = {};
  this.deathY = config.deathY;
  this.mapHeight = 0;
  this.mapDims = null;
  this.setMaps = function (X) {
    this.maps = X || maps;
  };
  this.getRandomMap = function () {
    return UTILS.randInt(0, this.maps.length - 1);
  };
  this.asyncGenerate = function (X, Y, Z, a0) {
    const { Worker } = (
      typeof require == "undefined" ? require("worker_threads") : require
    )("worker_threads");
    return new Promise((resolve, reject) => {
      var id = mapGenID(X, Y);
      if (!Z && this.lastGen === id) {
        this.finishGenerate();
        resolve();
        return;
      }
      let a5 = (a8) => {
        var a9 = {
          gameObjects: {},
        };
        for (var aa in a8._ctx.gameObjects) {
          var ab = a8._ctx.gameObjects[aa];
          var ac = new GameObject(ab, parseInt(aa), false);
          a9.gameObjects[aa] = ac;
        }
        for (var aa in a9.gameObjects) {
          ab = a8._ctx.gameObjects[aa];
          ac = a9.gameObjects[aa];
          for (var ad of config.gameObjectReferenceProps) {
            if (typeof ab[ad] == "number") {
              ac[ad] = a9.gameObjects[ab[ad]];
            }
          }
        }
        (function ae(af, ag, ah, ai = {}) {
          for (var aj in ah) {
            var ak;
            var al = ag[aj];
            var am = ah[aj];
            if (am.props) {
              ak = ae(af, al, am.props, ai[aj]);
            } else if (am.isGameObject) {
              ak = I(af, al);
            } else if (am.isTerrainConfig) {
              if (al) {
                ai.terrain = TERRAIN.fromConfig(al);
                ai.terrain.rotation.x = -Math.PI / 2;
                ak = al;
              } else {
                ak = null;
              }
            } else if (am.isZoneConfig) {
              if (al) {
                ai.zone = v.fromConfig(al);
                ak = al;
              } else {
                ak = null;
              }
            } else {
              ak = al;
            }
            ai[aj] = ak;
          }
          return ai;
        })(a9, a8, config.mapGenProps, this);
        resolve();
      };
      var data = {
        maps: this.maps,
        generate: {
          index: X,
          mode: Y,
          force: Z,
          isCustom: a0,
        },
      };
      const mapWorker = new Worker(process.cwd() + "/src/data/mapWorker.js", {
        workerData: JSON.stringify(data),
      });
      mapWorker.on("message", (a8) => {
        var a9;
        try {
          a9 = JSON.parse(a8);
        } catch (aa) {
          reject(aa);
          return;
        }
        try {
          a5(a9);
        } catch (ab) {
          reject(ab);
        }
      });
      mapWorker.on("error", (a8) => {
        console.warn("Error from map worker", {
          err: a8 + "",
        });
        reject(a8);
      });
      mapWorker.on("exit", (a8) => {
        if (a8 !== 0) {
          reject("Worker stopped with exit code " + a8);
        }
      });
    });
  };
  var V = "";
  var W = "";
  this.generate = function (id, mode, genMap, a0) {
    var mapData = this.maps[id];
    mapData.game = mapData.game || {};
    //game.map.generate(14, window.lastMode, false, false);
    this.config = {};
    var configItem;
    for (var i = 0; i < config.gameConfig.length; ++i) {
      if ((configItem = config.gameConfig[i]).bool) {
        this.config[configItem.varN] =
          mapData.game[configItem.varN] == null
            ? configItem.def
            : !!mapData.game[configItem.varN];
      } else if (configItem.input) {
        var a4 = mapData.game[configItem.varN];
        if (!UTILS.isString(a4)) {
          a4 = configItem.def;
        }
        this.config[configItem.varN] = UTILS.sanitizeStr(a4);
        if (a4.length > 16) {
          a4 = a4.substring(0, 16);
        }
      } else if (configItem.select) {
        this.config[configItem.varN] =
          configItem.options[mapData.game[configItem.varN]] == null
            ? configItem.def
            : parseInt(mapData.game[configItem.varN]);
      } else {
        a4 = mapData.game[configItem.varN];
        if (!UTILS.isNumber(a4)) {
          a4 = configItem.def;
        }
        this.config[configItem.varN] = UTILS.limitMM(
          a4,
          configItem.min,
          configItem.max,
        );
      }
    }
    this.deathY =
      mapData.dthY != null && UTILS.isNumber(mapData.dthY)
        ? mapData.dthY
        : config.deathY;
    if (RENDER) {
      try {
        mapInfo.textContent = mode.alias + "_" + mapData.name;
        mapInfo.classList.toggle("click", !!mapData.creator);
        mapInfo.onclick = mapData.creator
          ? () => window.openURL("/social.html?p=map&q=" + mapData.name)
          : null;
        gameMessage.innerHTML = specGMessage.innerHTML = "";
        curGameInfo.innerHTML =
          mode.name +
          "<div style='color:rgba(255,255,255,0.6)'>on " +
          mapData.name +
          "</div>" +
          (mapData.creator
            ? "<div style='color:#fff'><span style='color:rgba(255,255,255,0.6)'>by</span> " +
              mapData.creator +
              "</div>"
            : "");
        specGameInfo.textContent = mode.name;
      } catch (au) {}
    }
    if (RENDER && V != mapData.modURL) {
      if ((V = mapData.modURL) && V != "") {
        loadModPack(V, true, true);
      }
    }
    if (RENDER && W != mapData.welMsg) {
      if ((W = mapData.welMsg) && W != "") {
        welcome(W);
      }
    }
    var a5 = mapGenID(id, mode);
    if (genMap || this.lastGen !== a5) {
      this.lastGen = a5;
      if (RENDER) {
        RENDER.clearInstances();
      }
      this.manager.removeAll();
      if (RENDER) {
        RENDER.init(mapData, mode);
      }
      if (PARTICLES) {
        PARTICLES.reset();
        RENDER.scene.add(PARTICLES.ExplosionManager);
      }
      if (
        mapData.terrainSeed &&
        mapData.terrainWidth &&
        mapData.terrainHeight
      ) {
        this.terrainConfig = UTILS.extractProperties(
          mapData,
          TERRAIN.CONFIG_PROPS,
        );
        this.terrain = TERRAIN.fromConfig(this.terrainConfig);
        this.terrain.rotation.x = -Math.PI / 2;
        if (RENDER) {
          RENDER.scene.add(this.terrain);
        }
        if (this.terrain.genObjs) {
          for (var a6 in this.terrain.objPos) {
            if (this.terrain.objPos.hasOwnProperty(a6)) {
              for (i = 0; i < this.terrain.objPos[a6].length; i++) {
                this.manager.addTerrObj(
                  this.terrain.objPos[a6][i],
                  a6,
                  this.terrain,
                  PARTICLES,
                );
              }
            }
          }
          this.terrain.objPos = null;
        }
      } else {
        this.terrain = null;
      }
      if (mapData.zone && mapData.zoneSize && mapData.zoneSpeed) {
        this.zoneConfig = UTILS.extractProperties(mapData, v.CONFIG_PROPS);
        this.zone = v.fromConfig(this.zoneConfig, RENDER);
        if (RENDER) {
          RENDER.scene.add(this.zone);
        }
      } else {
        this.zone = null;
      }
      var a7 = 0;
      var a8 = 0;
      var a9 = 0;
      var aa = 0;
      var ab = 0;
      this.mapDims = {
        minX: 0,
        maxX: 0,
        minZ: 0,
        maxZ: 0,
      };
      var ac = mapData.colors || [];
      var ad = ["e", "c"];
      for (i = 0; i < mapData.objects.length; ++i) {
        OBJECT = mapData.objects[i];
        var ae;
        var af = UTILS.limit(OBJECT.p[0], config.positionRange).round(2);
        var ag = UTILS.limit(OBJECT.p[1], config.positionRange).round(2);
        var ah = UTILS.limit(OBJECT.p[2], config.positionRange).round(2);
        var ai = (parseFloat(OBJECT.s[0]) || 0).round(2);
        var aj = (parseFloat(OBJECT.s[1]) || 0).round(2);
        var ak = (parseFloat(OBJECT.s[2]) || 0).round(2);
        ae =
          OBJECT.at == null
            ? OBJECT.t.toLowerCase() + "_" + (OBJECT.t == "GRASS" ? 1 : 0)
            : parseInt(OBJECT.at || 0) + "/texture";
        if (OBJECT.f && typeof OBJECT.f == "string") {
          try {
            OBJECT.f = UTILS.convertFaces(OBJECT.f);
          } catch (av) {
            OBJECT.f = null;
          }
        }
        for (var al = 0; al < ad.length; al++) {
          if (OBJECT[ad[al] + "i"] != null && ac[OBJECT[ad[al] + "i"]]) {
            OBJECT[ad[al]] = ac[OBJECT[ad[al] + "i"]];
            delete OBJECT[ad[al] + "i"];
          }
        }
        if (af - ai / 2 < this.mapDims.minX) {
          this.mapDims.minX = af - ai / 2;
        }
        if (af + ai / 2 > this.mapDims.maxX) {
          this.mapDims.maxX = af + ai / 2;
        }
        if (ah - ak / 2 < this.mapDims.minZ) {
          this.mapDims.minZ = ah - ak / 2;
        }
        if (ah + ak / 2 > this.mapDims.maxZ) {
          this.mapDims.maxZ = ah + ak / 2;
        }
        if (!OBJECT.l && !OBJECT.col && OBJECT.i == "CUBE") {
          if (af - ai < a7) {
            a7 = af - ai;
          }
          if (af + ai > a8) {
            a8 = af + ai;
          }
          if (ah - ak < a9) {
            a9 = ah - ak;
          }
          if (ah + ak > aa) {
            aa = ah + ak;
          }
          if (ag + aj > ab) {
            ab = ag + aj;
          }
        }
        if (OBJECT.i == "CUBE") {
          var am = 1;
          for (al = 0; al < mapData.objects.length; ++al) {
            if (
              (U = mapData.objects[al]).i == "CUBE" &&
              OBJECT != U &&
              ag <= U.p[1] + U.s[1] &&
              ag >= U.p[1] &&
              af + ai / 2 < U.p[0] + U.s[0] / 2 &&
              af - ai / 2 > U.p[0] - U.s[0] / 2 &&
              ah + ak / 2 < U.p[2] + U.s[2] / 2 &&
              ah - ak / 2 > U.p[2] - U.s[2] / 2
            ) {
              am = 0;
              break;
            }
          }
          this.manager.addBlock(
            af,
            ag,
            ah,
            ai,
            ak,
            aj,
            [
              OBJECT.f && OBJECT.f[0] != null ? OBJECT.f[0] : 1,
              OBJECT.f && OBJECT.f[1] != null ? OBJECT.f[1] : 1,
              OBJECT.f && OBJECT.f[2] != null ? OBJECT.f[2] : 1,
              am ? (OBJECT.f && OBJECT.f[3] != null ? OBJECT.f[3] : 1) : 0,
              OBJECT.f && OBJECT.f[4] != null ? OBJECT.f[4] : 1,
              OBJECT.f && OBJECT.f[5] != null ? OBJECT.f[5] : 1,
            ],
            {
              src: ae,
              asset: OBJECT.at != null,
              colr: OBJECT.c,
              emissive: OBJECT.e || null,
              opacity: OBJECT.o != 1 && OBJECT.o != null ? OBJECT.o : 1,
              transparent: OBJECT.o != 1 && OBJECT.o != null,
              penetrable: OBJECT.pe,
              health: parseInt(OBJECT.h || OBJECT.hp) || 0,
              canDestroy: OBJECT.cdy != null,
              wallJumpable: OBJECT.wj == null,
              startDestroyed: OBJECT.sd != null,
              respawnT: (parseFloat(OBJECT.rt) || 0) * 1000,
              respawnR: OBJECT.rr != null,
              amb: mapData.nAmb || OBJECT.ab != null ? null : config.ambientVal,
              yR: OBJECT.r ? OBJECT.r[0] : 0,
              xR: OBJECT.r ? OBJECT.r[1] : 0,
              zR: OBJECT.r ? OBJECT.r[2] : 0,
              noCol: OBJECT.l || OBJECT.col,
              isBorder: OBJECT.bo,
              noVis: OBJECT.v,
              movT: OBJECT.ts != null && OBJECT.ts / 10000,
              movD: OBJECT.td,
              noAmb: OBJECT.ab != null,
              interface: parseInt(OBJECT.in) || null,
              texOffX: parseFloat(OBJECT.tox) || 0,
              texOffY: parseFloat(OBJECT.toy) || 0,
              noFog: OBJECT.nf != null,
              scale: OBJECT.tsr == null ? undefined : 0,
              dynamic: OBJECT.dyn != null,
              gravity: parseFloat(OBJECT.grv) || 0,
            },
          );
        } else if (OBJECT.i == "SPHERE") {
          this.manager.addSphere(af, ag, ah, ai, ak, aj, {
            src: ae,
            asset: OBJECT.at != null,
            colr: OBJECT.c,
            emissive: OBJECT.e || null,
            opacity: OBJECT.o != 1 && OBJECT.o != null ? OBJECT.o : 1,
            transparent: OBJECT.o != 1 && OBJECT.o != null,
            amb: mapData.nAmb || OBJECT.ab != null ? null : config.ambientVal,
            yR: OBJECT.r ? OBJECT.r[0] : 0,
            xR: OBJECT.r ? OBJECT.r[1] : 0,
            zR: OBJECT.r ? OBJECT.r[2] : 0,
            noVis: OBJECT.v,
            movT: OBJECT.ts != null && OBJECT.ts / 10000,
            movD: OBJECT.td,
            noAmb: OBJECT.ab != null,
            texOffX: parseFloat(OBJECT.tox) || 0,
            texOffY: parseFloat(OBJECT.toy) || 0,
            noFog: OBJECT.nf != null,
            wallJumpable: OBJECT.wj == null,
          });
        } else if (OBJECT.i == "POINT_LIGHT") {
          this.manager.addPointLight(af, ag, ah, {
            colr: OBJECT.c,
            intensity: parseFloat(OBJECT.li) || 1,
            distance: parseFloat(OBJECT.lds) || 0,
            decay: parseFloat(OBJECT.ld) || 1,
          });
        } else if (OBJECT.i == "GATE") {
          this.manager.addGate(af, ag, ah, ai, ak, aj, {
            src: ae,
            asset: OBJECT.at != null,
            colr: OBJECT.c,
            emissive: OBJECT.e || null,
            opacity: OBJECT.o != 1 && OBJECT.o != null ? OBJECT.o : 1,
            transparent: OBJECT.o != 1 && OBJECT.o != null,
            penetrable: OBJECT.pe,
            amb: mapData.nAmb || OBJECT.ab != null ? null : config.ambientVal,
            yR: OBJECT.r ? OBJECT.r[0] : 0,
            xR: OBJECT.r ? OBJECT.r[1] : 0,
            zR: OBJECT.r ? OBJECT.r[2] : 0,
            isBorder: OBJECT.bo,
            noVis: OBJECT.v,
            movT: OBJECT.ts != null && OBJECT.ts / 10000,
            movD: OBJECT.td,
            noAmb: OBJECT.ab != null,
            scoreP: parseInt(OBJECT.sp) || 0,
            noMsg: OBJECT.nm != null,
            method: parseInt(OBJECT.md) || 0,
            closeable: OBJECT.cl != null,
            startClosed: OBJECT.stc != null,
            interface: parseInt(OBJECT.in) || null,
            texOffX: parseFloat(OBJECT.tox) || 0,
            texOffY: parseFloat(OBJECT.toy) || 0,
            team: parseInt(OBJECT.tm || 0) || 0,
            wallJumpable: OBJECT.wj == null,
          });
        } else if (OBJECT.i == "TRIGGER") {
          this.manager.addTrigger(af, ag, ah, ai, ak, aj, {
            src: ae,
            asset: OBJECT.at != null,
            colr: OBJECT.c,
            emissive: OBJECT.e || null,
            opacity: OBJECT.o != 1 && OBJECT.o != null ? OBJECT.o : 1,
            transparent: OBJECT.o != 1 && OBJECT.o != null,
            health: parseInt(OBJECT.h || OBJECT.hp) || 0,
            canDestroy: OBJECT.cdy != null,
            startDestroyed: OBJECT.sd != null,
            selfDestruct: OBJECT.sfd != null,
            respawnT: (parseFloat(OBJECT.rt) || 0) * 1000,
            respawnR: OBJECT.rr != null,
            amb: mapData.nAmb || OBJECT.ab != null ? null : config.ambientVal,
            yR: OBJECT.r ? OBJECT.r[0] : 0,
            xR: OBJECT.r ? OBJECT.r[1] : 0,
            zR: OBJECT.r ? OBJECT.r[2] : 0,
            noVis: OBJECT.v,
            movT: OBJECT.ts != null && OBJECT.ts / 10000,
            movD: OBJECT.td,
            noAmb: OBJECT.ab != null,
            constant: parseInt(OBJECT.tc) || 0,
            constantTxt: OBJECT.tct,
            constantEvent: parseInt(OBJECT.tce) || 0,
            event: parseInt(OBJECT.te) || 0,
            eventN: triggers.events[parseInt(OBJECT.te) || 0],
            chance: parseInt(OBJECT.cha) || 0,
            action: parseInt(OBJECT.ta) || 0,
            interface: parseInt(OBJECT.in) || null,
            interfaceT: parseInt(OBJECT.tin) || null,
            snd: parseInt(OBJECT.esa || OBJECT.es) || 0,
            assetSnd: OBJECT.esa != null,
            vol: parseFloat(OBJECT.ev) || 1,
            rate: parseFloat(OBJECT.er) || 1,
            emitfrom: parseInt(OBJECT.ef) || 0,
            texOffX: parseFloat(OBJECT.tox) || 0,
            texOffY: parseFloat(OBJECT.toy) || 0,
            team: parseInt(OBJECT.tm || 0) || 0,
            singleUse: OBJECT.su != null,
            wallJumpable: OBJECT.wj == null,
          });
        } else if (OBJECT.i == "TERMINAL") {
          this.manager.addTerminal(af, ag, ah, ai, ak, aj, {
            src: ae,
            asset: OBJECT.at != null,
            colr: OBJECT.c,
            emissive: OBJECT.e || null,
            opacity: OBJECT.o != 1 && OBJECT.o != null ? OBJECT.o : 1,
            transparent: OBJECT.o != 1 && OBJECT.o != null,
            health: parseInt(OBJECT.h || OBJECT.hp) || 0,
            canDestroy: OBJECT.cdy != null,
            startDestroyed: OBJECT.sd != null,
            amb: mapData.nAmb || OBJECT.ab != null ? null : config.ambientVal,
            yR: OBJECT.r ? OBJECT.r[0] : 0,
            xR: OBJECT.r ? OBJECT.r[1] : 0,
            zR: OBJECT.r ? OBJECT.r[2] : 0,
            noVis: OBJECT.v,
            movT: OBJECT.ts != null && OBJECT.ts / 10000,
            movD: OBJECT.td,
            noAmb: OBJECT.ab != null,
            interface: parseInt(OBJECT.in) || null,
            noMsg: OBJECT.nm != null,
            texOffX: parseFloat(OBJECT.tox) || 0,
            texOffY: parseFloat(OBJECT.toy) || 0,
            team: parseInt(OBJECT.tm || 0) || 0,
            wallJumpable: OBJECT.wj == null,
          });
        } else if (OBJECT.i == "DEPOSIT_BOX") {
          this.manager.addBank(af, ag, ah, ai, ak, aj, {
            src: ae,
            asset: OBJECT.at != null,
            colr: OBJECT.c,
            emissive: OBJECT.e || null,
            opacity: OBJECT.o != 1 && OBJECT.o != null ? OBJECT.o : 1,
            transparent: OBJECT.o != 1 && OBJECT.o != null,
            penetrable: OBJECT.pe,
            amb: mapData.nAmb || OBJECT.ab != null ? null : config.ambientVal,
            yR: OBJECT.r ? OBJECT.r[0] : 0,
            xR: OBJECT.r ? OBJECT.r[1] : 0,
            zR: OBJECT.r ? OBJECT.r[2] : 0,
            isBorder: OBJECT.bo,
            noVis: OBJECT.v,
            movT: OBJECT.ts != null && OBJECT.ts / 10000,
            movD: OBJECT.td,
            noAmb: OBJECT.ab != null,
            interface: parseInt(OBJECT.in) || null,
            withdraw: OBJECT.wd == null ? 1000 : parseInt(OBJECT.wd) || 0,
            deposit: OBJECT.dp == null ? 1000 : parseInt(OBJECT.dp) || 0,
            texOffX: parseFloat(OBJECT.tox) || 0,
            texOffY: parseFloat(OBJECT.toy) || 0,
            team: parseInt(OBJECT.tm || 0) || 0,
            wallJumpable: OBJECT.wj == null,
          });
        } else if (OBJECT.i == "LIGHT_CONE") {
          if (RENDER && RENDER.mapDet) {
            this.manager.addLightCone(af, ag, ah, ai, ak, aj, {
              src: "lightcone_" + (OBJECT.fc == null ? 0 : 1),
              colr: OBJECT.c,
              opacity: OBJECT.o != 1 && OBJECT.o != null ? OBJECT.o : 1,
              yR: OBJECT.r ? OBJECT.r[0] : 0,
              xR: OBJECT.r ? OBJECT.r[1] : 0,
              zR: OBJECT.r ? OBJECT.r[2] : 0,
              noVis: OBJECT.v,
              movT: OBJECT.ts != null && OBJECT.ts / 10000,
              movD: OBJECT.td,
            });
          }
        } else if (OBJECT.i == "CYLINDER") {
          this.manager.addCylinder(af, ag, ah, ai, ak, aj, {
            src: ae,
            asset: OBJECT.at != null,
            colr: OBJECT.c,
            emissive: OBJECT.e || null,
            opacity: OBJECT.o != 1 && OBJECT.o != null ? OBJECT.o : 1,
            transparent: OBJECT.o != 1 && OBJECT.o != null,
            yR: OBJECT.r ? OBJECT.r[0] : 0,
            xR: OBJECT.r ? OBJECT.r[1] : 0,
            zR: OBJECT.r ? OBJECT.r[2] : 0,
            noVis: OBJECT.v,
            movT: OBJECT.ts != null && OBJECT.ts / 10000,
            movD: OBJECT.td,
            spin: parseInt(OBJECT.spn || 0) || 0,
            noCol: OBJECT.l || OBJECT.col,
            health: parseInt(OBJECT.h || OBJECT.hp) || 0,
            canDestroy: OBJECT.cdy != null,
            startDestroyed: OBJECT.sd != null,
            respawnT: (parseFloat(OBJECT.rt) || 0) * 1000,
            respawnR: OBJECT.rr != null,
            interface: parseInt(OBJECT.in) || null,
            open: OBJECT.opn != null,
            wallJumpable: OBJECT.wj == null,
          });
        } else if (OBJECT.i == "SOUND_EMITTER") {
          this.manager.addEmitter(af, ag, ah, {
            snd: parseInt(OBJECT.esa || OBJECT.es) || 0,
            assetSnd: OBJECT.esa != null,
            vol: parseFloat(OBJECT.ev) || 1,
            rate: parseFloat(OBJECT.er) || 1,
            dist: parseInt(OBJECT.ed) || 0,
            roll: parseFloat(OBJECT.ero) || 0,
          });
        } else if (OBJECT.i == "OBJECTIVE") {
          this.manager.addObjective(af, ag, ah, ai, ak, aj, OBJECT.obi || 0);
        } else if (OBJECT.i == "BOMB_SITE") {
          this.manager.addBombSite(af, ag, ah, ai, ak, aj);
        } else if (OBJECT.i == "FLAG") {
          this.manager.addFlag(af, ag, ah, parseInt(OBJECT.tm || 0) + 1);
        } else if (OBJECT.i == "BOOST_PAD") {
          this.manager.addPad(
            af,
            ag,
            ah,
            {
              bounce: parseFloat(OBJECT.bm) || 1,
              crouch: OBJECT.cr == null,
              noVis: OBJECT.v,
              yR: OBJECT.r ? OBJECT.r[0] : 0,
              xR: OBJECT.r ? OBJECT.r[1] : 0,
              zR: OBJECT.r ? OBJECT.r[2] : 0,
            },
            OBJECT.r,
          );
        } else if (OBJECT.i == "WEAPON_PICKUP") {
          this.manager.addWeapon(
            af,
            ag,
            ah,
            {
              scoreP: parseInt(OBJECT.sp) || 0,
              noMsg: OBJECT.nm != null,
              method: parseInt(OBJECT.md) || 0,
              noRep: OBJECT.wr,
              weaponId: parseInt(OBJECT.w || OBJECT.wid || 0),
              random: OBJECT.rw != null,
              team: parseInt(OBJECT.tm || 0) || 0,
            },
            OBJECT.r ? OBJECT.r[2] : 0,
            OBJECT.r ? OBJECT.r[0] : 0,
            OBJECT.r ? OBJECT.r[1] : 0,
            weapons,
          );
        } else if (OBJECT.i == "SHOWCASE") {
          this.manager.addShowcase(
            af,
            ag,
            ah,
            OBJECT.r,
            ai / 2,
            aj / 2,
            ak / 2,
            {
              itemID: parseInt(OBJECT.skin || 0),
              opacity: OBJECT.o != 1 && OBJECT.o != null ? OBJECT.o : 1,
              transparent: OBJECT.o != 1 && OBJECT.o != null,
              colr: OBJECT.c,
              noAmb: OBJECT.ab != null,
              mSize: parseFloat(OBJECT.ms),
            },
            weapons,
            store,
          );
        } else if (OBJECT.i == "PARTICLES") {
          if (PARTICLES) {
            PARTICLES.area(af, ag, ah, ai, aj, ak, {
              txt: parseInt(OBJECT.pr) || 0,
              spd: parseInt(OBJECT.psp) || 0,
              decl: parseInt(OBJECT.pd) || 1,
              cnt: parseInt(OBJECT.pc) || 0,
              grav: parseInt(OBJECT.pg) || 0,
              scl: parseInt(OBJECT.psc) || 1,
              siz: parseInt(OBJECT.ps) || 1,
              dir: OBJECT.d || 0,
              colr: OBJECT.c,
              blend: OBJECT.pb || 0,
            });
          }
        } else if (OBJECT.i == "PLANE" || OBJECT.i == "BILLBOARD") {
          this.manager.addPlane(
            af,
            ag,
            ah,
            ak / 2,
            ai / 2,
            {
              src:
                OBJECT.i == "BILLBOARD"
                  ? "pubs/b_" +
                    (OBJECT.bb || UTILS.randInt(1, config.billboardCnt))
                  : ae,
              asset: OBJECT.at != null,
              scale: OBJECT.i == "PLANE" && OBJECT.tsr == null ? 2 : 0,
              emissive: OBJECT.e || null,
              noise: OBJECT.en || 0,
              opacity: OBJECT.o != 1 && OBJECT.o != null ? OBJECT.o : 1,
              penetrable: OBJECT.pe,
              transparent: OBJECT.o != 1 && OBJECT.o != null,
              health: parseInt(OBJECT.h || OBJECT.hp) || 0,
              canDestroy: OBJECT.cdy != null,
              startDestroyed: OBJECT.sd != null,
              respawnT: (parseFloat(OBJECT.rt) || 0) * 1000,
              respawnR: OBJECT.rr != null,
              colr: OBJECT.c,
              noCol: OBJECT.l || OBJECT.col,
              noVis: OBJECT.v,
              side: OBJECT.i == "BILLBOARD" ? 2 : 0,
              movT: OBJECT.ts != null && OBJECT.ts / 10000,
              movD: OBJECT.td,
              noAmb: OBJECT.ab != null,
              interface: parseInt(OBJECT.in) || null,
              showAd: OBJECT.sad != null,
              text: this.billboard.txt,
              textCol: this.billboard.txtCol,
              bgCol: this.billboard.bgCol,
              texOffX: parseFloat(OBJECT.tox) || 0,
              texOffY: parseFloat(OBJECT.toy) || 0,
              wallJumpable: OBJECT.wj == null,
            },
            OBJECT.r ? OBJECT.r[2] : 0,
            (OBJECT.r ? OBJECT.r[0] : 0) - Math.PI / 2,
            OBJECT.r ? OBJECT.r[1] : 0,
          );
        } else if (OBJECT.i == "LIQUID") {
          this.manager.addLiquid(
            af,
            ag,
            ah,
            ak / 2,
            ai / 2,
            {
              src: ae,
              asset: OBJECT.at != null,
              emissive: OBJECT.e || null,
              opacity: OBJECT.o != 1 && OBJECT.o != null ? OBJECT.o : 1,
              colr: OBJECT.c,
              noVis: OBJECT.v,
              movT: OBJECT.ts != null && OBJECT.ts / 10000,
              movD: OBJECT.td,
              noAmb: OBJECT.ab != null,
              wHeight: parseFloat(OBJECT.wh) || 0.5,
              wSpeed: parseFloat(OBJECT.ws) || 10,
              tilesX: parseInt(OBJECT.tx) || 10,
              tilesZ: parseInt(OBJECT.tz) || 10,
              texOffX: parseFloat(OBJECT.tox) || 0,
              texOffY: parseFloat(OBJECT.toy) || 0,
            },
            OBJECT.r ? OBJECT.r[2] : 0,
            (OBJECT.r ? OBJECT.r[0] : 0) - Math.PI / 2,
            OBJECT.r ? OBJECT.r[1] : 0,
          );
        } else if (OBJECT.i == "SIGN") {
          this.manager.addCanvas(
            af,
            ag,
            ah,
            ak / 2,
            ai / 2,
            {
              noCol: OBJECT.l || OBJECT.col,
              fontSize: parseInt(OBJECT.sf) || 10,
              text: OBJECT.st,
              tAlign: parseInt(OBJECT.sa) || 0,
              fcolr: OBJECT.sc,
              bcolr: OBJECT.sb,
              noBVis: OBJECT.bv,
              movT: OBJECT.ts != null && OBJECT.ts / 10000,
              movD: OBJECT.td,
            },
            OBJECT.r ? -OBJECT.r[2] : 0,
            (OBJECT.r ? OBJECT.r[0] : 0) - Math.PI / 2,
            OBJECT.r ? OBJECT.r[1] : 0,
          );
        } else if (OBJECT.i == "SPECTATE_CAM") {
          this.manager.addSpectateCam(af, ag, ah, {
            objLink: OBJECT.obi || 0,
            yR: OBJECT.r ? OBJECT.r[0] : 0,
            xR: OBJECT.r ? OBJECT.r[1] : 0,
            zR: OBJECT.r ? OBJECT.r[2] : 0,
          });
        } else if (OBJECT.i == "RAMP") {
          this.manager.addRamp(
            af,
            ag,
            ah,
            ai,
            aj,
            ak,
            ((OBJECT.d || 0) * Math.PI) / 2,
            {
              src: ae,
              asset: OBJECT.at != null,
              boost: OBJECT.b,
              scale: OBJECT.tsr == null ? 1 : 0,
              emissive: OBJECT.e || null,
              opacity: OBJECT.o != 1 && OBJECT.o != null ? OBJECT.o : 1,
              transparent: OBJECT.o != 1 && OBJECT.o != null,
              colr: OBJECT.c,
              noVis: OBJECT.v,
              movT: OBJECT.ts != null && OBJECT.ts / 10000,
              movD: OBJECT.td,
              noAmb: OBJECT.ab != null,
              texOffX: parseFloat(OBJECT.tox) || 0,
              texOffY: parseFloat(OBJECT.toy) || 0,
            },
          );
        } else if (OBJECT.i == "PREMIUM_ZONE") {
          this.manager.addPremiumZone(af, ag, ah, ai, ak, aj, {
            isBorder: OBJECT.bo,
          });
        } else if (OBJECT.i == "VERIFIED_ZONE") {
          this.manager.addVerifiedZone(af, ag, ah, ai, ak, aj, {
            isBorder: OBJECT.bo,
          });
        } else if (OBJECT.i == "TEAM_ZONE") {
          this.manager.addTeamZone(af, ag, ah, ai, ak, aj, {
            team: parseInt(OBJECT.tm || 0) || 0,
            isBorder: OBJECT.bo,
          });
        } else if (OBJECT.i == "SCORE_ZONE") {
          this.manager.addScoreZone(
            af,
            ag,
            ah,
            ai,
            ak,
            aj,
            parseInt(OBJECT.sp) || 1,
          );
        } else if (OBJECT.i == "DEATH_ZONE") {
          this.manager.addDeathZone(af, ag, ah, ai, ak, aj);
        } else if (OBJECT.i == "CHECK_POINT") {
          this.manager.addCheckPoint(af, ag, ah, ai, ak, aj, {
            singleUse: OBJECT.su != null,
            direction: OBJECT.d || 0,
            team: parseInt(OBJECT.tm || 0) || 0,
          });
        } else if (OBJECT.i == "TELEPORTER") {
          this.manager.addTeleporter(af, ag, ah, ai, ak, aj, {
            direction: OBJECT.d || 0,
            forceDir: OBJECT.fd != null,
            channel: parseInt(OBJECT.ch || 0),
            node: parseInt(OBJECT.n || 0),
            momentum: OBJECT.m != null,
            team: parseInt(OBJECT.tm || 0) || 0,
          });
        } else if (OBJECT.i == "LADDER") {
          this.manager.addLadder(
            af,
            ag,
            ah,
            aj,
            ((OBJECT.d || 0) * Math.PI) / 2,
            {
              src: ae,
              asset: OBJECT.at != null,
              scale: OBJECT.tsr == null ? 0.02 : 1,
              emissive: OBJECT.e || null,
              opacity: OBJECT.o != 1 && OBJECT.o != null ? OBJECT.o : 1,
              transparent: OBJECT.o != 1 && OBJECT.o != null,
              colr: OBJECT.c,
              noVis: OBJECT.v,
              texOffX: parseFloat(OBJECT.tox) || 0,
              texOffY: parseFloat(OBJECT.toy) || 0,
              wallJumpable: OBJECT.wj == null,
            },
          );
        } else if (OBJECT.i == "BOT") {
          this.manager.addAI(af, ag, ah, OBJECT.r, ai / 2, aj / 2, ak / 2, {
            src: OBJECT.aid ? "model" : "ghost_0",
            asset: OBJECT.aid,
            health: parseInt(OBJECT.h || OBJECT.hp) || 0,
            respawnT: (parseFloat(OBJECT.rt) || 0) * 1000,
            respawnR: OBJECT.rr != null,
            speed: parseFloat(OBJECT.spd) || 0,
            turnSpd: parseFloat(OBJECT.tsd) || 0,
            grv: parseFloat(OBJECT.grv) || 0,
            frate: parseInt(OBJECT.fr) || 0,
            visDis: parseInt(OBJECT.vd) || 0,
            idl: parseInt(OBJECT.idl) || 0,
            dth: parseInt(OBJECT.dth) || 0,
            atk: parseInt(OBJECT.atk) || 0,
            agr: parseInt(OBJECT.agr) || 0,
            score: parseInt(OBJECT.sp) || 0,
            proj: parseInt(OBJECT.pj) || 0,
            reward: OBJECT.rew,
            behav: parseInt(OBJECT.bh) || 0,
            canShoot: OBJECT.cs != null,
            canHit: OBJECT.cnh != null,
            xrayVis: OBJECT.xv != null,
            opacity: OBJECT.o != 1 && OBJECT.o != null ? OBJECT.o : 1,
            transparent: OBJECT.o != 1 && OBJECT.o != null,
            colr: OBJECT.c,
            noCol: OBJECT.l || OBJECT.col,
            noVis: OBJECT.v,
            mSize: parseFloat(OBJECT.ms),
            aiName: OBJECT.ain,
            constant: parseInt(OBJECT.tc) || 0,
            constantTxt: OBJECT.tct,
            constantEvent: parseInt(OBJECT.tce) || 0,
            event: parseInt(OBJECT.te) || 0,
            canTrigger: OBJECT.ct != null,
            chance: parseInt(OBJECT.cha) || 0,
            eventN: triggers.events[parseInt(OBJECT.te) || 15],
            action: parseInt(OBJECT.ta) || 0,
            interface: parseInt(OBJECT.in) || null,
            interfaceT: parseInt(OBJECT.tin) || null,
            snd: parseInt(OBJECT.esa || OBJECT.es) || 0,
            assetSnd: OBJECT.esa != null,
            vol: parseFloat(OBJECT.ev) || 1,
            rate: parseFloat(OBJECT.er) || 1,
            emitfrom: parseInt(OBJECT.ef) || 0,
          });
        } else if (OBJECT.i == "RUNE") {
          this.manager.addPlane(
            af,
            ag + 0.01,
            ah,
            ak / 2,
            ai / 2,
            {
              src: "rune_0",
              scale: 0,
              emissive: OBJECT.e || null,
              opacity: OBJECT.o != 1 && OBJECT.o != null ? OBJECT.o : 1,
              transparent: OBJECT.o != 1 && OBJECT.o != null,
              colr: OBJECT.c,
              noCol: OBJECT.l || OBJECT.col,
              noVis: OBJECT.v,
              side: 2,
              shadows: false,
              alphaTest: prefabs.prefabs[57].alphaTest,
              movT: OBJECT.ts != null && OBJECT.ts / 10000,
              movD: OBJECT.td,
              noAmb: OBJECT.ab != null,
              wallJumpable: OBJECT.wj == null,
            },
            OBJECT.r ? OBJECT.r[2] : 0,
            (OBJECT.r ? OBJECT.r[0] : 0) - Math.PI / 2,
            OBJECT.r ? OBJECT.r[1] : 0,
          );
        } else if (OBJECT.i == "CUSTOM_ASSET") {
          this.manager.addAsset(af, ag, ah, OBJECT.r, ai / 2, aj / 2, ak / 2, {
            src: "model",
            asset: OBJECT.aid,
            health: parseInt(OBJECT.h || OBJECT.hp) || 0,
            canDestroy: OBJECT.cdy != null,
            startDestroyed: OBJECT.sd != null,
            respawnT: (parseFloat(OBJECT.rt) || 0) * 1000,
            respawnR: OBJECT.rr != null,
            opacity: OBJECT.o != 1 && OBJECT.o != null ? OBJECT.o : 1,
            transparent: OBJECT.o != 1 && OBJECT.o != null,
            colr: OBJECT.c,
            noCol: OBJECT.l || OBJECT.col,
            noVis: OBJECT.v,
            noAmb: OBJECT.ab != null,
            interface: parseInt(OBJECT.in) || null,
            mSize: parseFloat(OBJECT.ms),
            noSmooth: OBJECT.txs != null,
            spin: parseInt(OBJECT.spn || 0) || 0,
            wallJumpable: OBJECT.wj == null,
          });
        } else if (!a0 || OBJECT.i.toUpperCase() != "EVENT") {
          this.manager.addMesh(af, ag, ah, OBJECT.r, ai / 2, aj / 2, ak / 2, {
            src: OBJECT.i.toLowerCase(),
            health: parseInt(OBJECT.h || OBJECT.hp) || 0,
            canDestroy: OBJECT.cdy != null,
            startDestroyed: OBJECT.sd != null,
            respawnT: (parseFloat(OBJECT.rt) || 0) * 1000,
            respawnR: OBJECT.rr != null,
            opacity: OBJECT.o != 1 && OBJECT.o != null ? OBJECT.o : 1,
            transparent: OBJECT.o != 1 && OBJECT.o != null,
            colr: OBJECT.c,
            noCol: OBJECT.l || OBJECT.col,
            noVis: OBJECT.v,
            noAmb: OBJECT.ab != null,
            interface: parseInt(OBJECT.in) || null,
            mSize: parseFloat(OBJECT.ms),
            wallJumpable: OBJECT.wj == null,
          });
        }
      }
      this.mapHeight = ab;
      this.mapDims.cX = (this.mapDims.minX + this.mapDims.maxX) / 2;
      this.mapDims.cZ = (this.mapDims.minZ + this.mapDims.maxZ) / 2;
      this.mapDims.sX = 350 / ((this.mapDims.maxX - this.mapDims.cX) * 2);
      this.mapDims.sZ = 350 / ((this.mapDims.maxZ - this.mapDims.cZ) * 2);
      this.manager.addNoisePlanes();
      if (this.terrain) {
        mapData.shadLength = this.terrain.sizeX * 1.2;
        mapData.shadWidth = this.terrain.sizeY * 1.2;
      } else {
        mapData.shadLength = Math.round(Math.abs(a8 - a7) / 2.5);
        mapData.shadWidth = Math.round(Math.abs(aa - a9) / 2.5);
      }
      if (RENDER) {
        RENDER.updateLightMap(mapData);
      }
      this.manager.aoOpac = 0.5;
      if (RENDER) {
        var colData;
        var ambOcScale = config.ambScale;
        for (i = 0; i < this.manager.objects.length; ++i) {
          if (
            !(OBJECT = this.manager.objects[i]).noVis &&
            (mode.id != "prop" || !OBJECT.propID) &&
            !OBJECT.complexMesh &&
            !OBJECT.health &&
            !OBJECT.canDestroy &&
            !OBJECT.noAmb &&
            !OBJECT.gate
          ) {
            for (al = i + 1; al < this.manager.objects.length; ++al) {
              if (
                !(U = this.manager.objects[al]).noVis &&
                (mode.id != "prop" || !U.propID) &&
                !U.health &&
                !U.canDestroy &&
                !U.noAmb &&
                !U.gate &&
                !U.complexMesh &&
                this.manager.collision(OBJECT, U, 0)
              ) {
                if (
                  (colData = UTILS.boxIntersection(OBJECT, U, "x", "z", [
                    Math.PI,
                    0,
                    Math.PI / 2,
                    -Math.PI / 2,
                  ]))
                ) {
                  for (var ap = 0; ap < colData.length; ++ap) {
                    if (!colData[ap].dontUse) {
                      var aq = UTILS.getIntersection(OBJECT, U, "y");
                      var ar =
                        ambOcScale * (OBJECT.aoMlt || 1) * (U.aoMlt || 1);
                      for (var as = 0; as < 2; as++) {
                        a4 =
                          (colData[ap].d + (Math.PI / 2) * as) % (Math.PI * 2);
                        ar = Math.min(
                          ar,
                          this.manager.limitAmb(
                            ambOcScale,
                            colData[ap],
                            a4,
                            "x",
                            "z",
                            OBJECT,
                            U,
                          ),
                        );
                      }
                      for (as = 0; as < 2; as++) {
                        a4 =
                          (colData[ap].d + (Math.PI / 2) * as) % (Math.PI * 2);
                        this.manager.addAmbient(
                          colData[ap].x + ar * Math.cos(a4),
                          aq.y,
                          colData[ap].z + ar * Math.sin(a4),
                          -a4 + Math.PI,
                          0,
                          0,
                          aq.height,
                          ar + config.ambOff,
                          1,
                        );
                        if (
                          a4 == Math.PI / 2 ||
                          a4 == -Math.PI / 2 ||
                          a4 == Math.PI * 1.5
                        ) {
                          var at = UTILS.limitRect(
                            colData[ap].z + ar * Math.sin(a4),
                            aq.y + ar + aq.height + config.ambOff,
                            ar,
                            ar,
                            0,
                            [OBJECT, U],
                            "z",
                            "y",
                          );
                          this.manager.addAmbient(
                            colData[ap].x + ar * Math.cos(a4),
                            at.y,
                            at.z,
                            -a4 + Math.PI,
                            Math.PI,
                            0,
                            at.length,
                            at.height,
                            0,
                            [OBJECT, U],
                            "g1-" + as + "-" + ap,
                            [colData[ap].x, aq.y + aq.height, colData[ap].z],
                          );
                          at = UTILS.limitRect(
                            colData[ap].z + ar * Math.sin(a4),
                            aq.y - ar - aq.height - config.ambOff,
                            ar,
                            ar,
                            0,
                            [OBJECT, U],
                            "z",
                            "y",
                          );
                          this.manager.addAmbient(
                            colData[ap].x + ar * Math.cos(a4),
                            at.y,
                            at.z,
                            -a4 + Math.PI,
                            0,
                            0,
                            at.length,
                            at.height,
                            0,
                            [OBJECT, U],
                            "g2-" + as + "-" + ap,
                            [colData[ap].x, aq.y - aq.height, colData[ap].z],
                          );
                        } else {
                          at = UTILS.limitRect(
                            colData[ap].x + ar * Math.cos(a4),
                            aq.y + ar + aq.height + config.ambOff,
                            ar,
                            ar,
                            0,
                            [OBJECT, U],
                            "x",
                            "y",
                          );
                          this.manager.addAmbient(
                            at.x,
                            at.y,
                            colData[ap].z + ar * Math.sin(a4),
                            -a4 + Math.PI,
                            Math.PI,
                            0,
                            at.width,
                            at.height,
                            0,
                            [OBJECT, U],
                            "g1-" + as + "-" + ap,
                            [colData[ap].x, aq.y + aq.height, colData[ap].z],
                          );
                          at = UTILS.limitRect(
                            colData[ap].x + ar * Math.cos(a4),
                            aq.y - ar - aq.height - config.ambOff,
                            ar,
                            ar,
                            0,
                            [OBJECT, U],
                            "x",
                            "y",
                          );
                          this.manager.addAmbient(
                            at.x,
                            at.y,
                            colData[ap].z + ar * Math.sin(a4),
                            -a4 + Math.PI,
                            0,
                            0,
                            at.width,
                            at.height,
                            0,
                            [OBJECT, U],
                            "g2-" + as + "-" + ap,
                            [colData[ap].x, aq.y - aq.height, colData[ap].z],
                          );
                        }
                      }
                    }
                  }
                }
                if (
                  (colData = UTILS.boxIntersection(OBJECT, U, "z", "y", [
                    Math.PI,
                    0,
                    -Math.PI / 2,
                    Math.PI / 2,
                  ]))
                ) {
                  for (ap = 0; ap < colData.length; ++ap) {
                    if (!colData[ap].dontUse) {
                      aq = UTILS.getIntersection(OBJECT, U, "x");
                      ar = ambOcScale * (OBJECT.aoMlt || 1) * (U.aoMlt || 1);
                      as = 0;
                      for (; as < 2; as++) {
                        a4 = colData[ap].d + (Math.PI / 2) * (as ? 0 : 1);
                        ar = Math.min(
                          ar,
                          this.manager.limitAmb(
                            ambOcScale,
                            colData[ap],
                            -a4 + Math.PI / 2,
                            "z",
                            "y",
                            OBJECT,
                            U,
                          ),
                        );
                      }
                      for (as = 0; as < 2; as++) {
                        a4 = colData[ap].d + (Math.PI / 2) * (as ? 0 : 1);
                        this.manager.addAmbient(
                          aq.x,
                          colData[ap].y + ar * Math.cos(a4),
                          colData[ap].z + ar * Math.sin(a4),
                          0,
                          a4,
                          -Math.PI / 2,
                          aq.width,
                          ar + config.ambOff,
                          1,
                        );
                        at = UTILS.limitRect(
                          aq.x + aq.width + ar + config.ambOff,
                          colData[ap].z + ar * Math.sin(a4),
                          ar,
                          ar,
                          0,
                          [OBJECT, U],
                          "x",
                          "z",
                        );
                        this.manager.addAmbient(
                          at.x,
                          colData[ap].y + ar * Math.cos(a4),
                          colData[ap].z + ar * Math.sin(a4),
                          Math.PI,
                          a4 == Math.PI ? a4 : -a4 % Math.PI,
                          a4 == Math.PI * 1.5 ? 0 : -Math.PI / 2,
                          a4 == Math.PI * 1.5 ? ar : at.length,
                          a4 == Math.PI * 1.5 ? at.length : ar,
                          0,
                          [OBJECT, U],
                          "g3-" + as + "-" + ap,
                          [aq.x + aq.width, colData[ap].y, colData[ap].z],
                        );
                        at = UTILS.limitRect(
                          aq.x - aq.width - ar - config.ambOff,
                          colData[ap].z + ar * Math.sin(a4),
                          ar,
                          ar,
                          Math.PI / 2,
                          [OBJECT, U],
                          "x",
                          "z",
                        );
                        this.manager.addAmbient(
                          at.x,
                          colData[ap].y + ar * Math.cos(a4),
                          colData[ap].z + ar * Math.sin(a4),
                          Math.PI,
                          -a4 % Math.PI,
                          a4 == Math.PI || a4 == Math.PI * 1.5
                            ? Math.PI / 2
                            : Math.PI,
                          a4 == Math.PI || a4 == Math.PI * 1.5 ? at.width : ar,
                          a4 == Math.PI || a4 == Math.PI * 1.5 ? ar : at.width,
                          0,
                          [OBJECT, U],
                          "g4-" + as + "-" + ap,
                          [aq.x - aq.width, colData[ap].y, colData[ap].z],
                        );
                      }
                    }
                  }
                }
                if (
                  (colData = UTILS.boxIntersection(OBJECT, U, "x", "y", [
                    Math.PI,
                    0,
                    -Math.PI / 2,
                    Math.PI / 2,
                  ]))
                ) {
                  for (ap = 0; ap < colData.length; ++ap) {
                    if (!colData[ap].dontUse) {
                      aq = UTILS.getIntersection(OBJECT, U, "z");
                      ar = ambOcScale * (OBJECT.aoMlt || 1) * (U.aoMlt || 1);
                      as = 0;
                      for (; as < 2; as++) {
                        a4 = colData[ap].d + (Math.PI / 2) * (as ? 0 : 1);
                        ar = Math.min(
                          ar,
                          this.manager.limitAmb(
                            ambOcScale,
                            colData[ap],
                            -a4 + Math.PI / 2,
                            "x",
                            "y",
                            OBJECT,
                            U,
                          ),
                        );
                      }
                      for (as = 0; as < 2; as++) {
                        a4 = colData[ap].d + (Math.PI / 2) * (as ? 0 : 1);
                        this.manager.addAmbient(
                          colData[ap].x + ar * Math.sin(a4),
                          colData[ap].y + ar * Math.cos(a4),
                          aq.z,
                          Math.PI / 2,
                          a4,
                          -Math.PI / 2,
                          aq.length,
                          ar + config.ambOff,
                          1,
                        );
                        if (a4 == Math.PI || a4 == 0) {
                          at = UTILS.limitRect(
                            colData[ap].z + ar * Math.sin(a4),
                            aq.z + aq.length + ar + config.ambOff,
                            ar,
                            ar,
                            Math.PI / 2,
                            [OBJECT, U],
                            "x",
                            "z",
                          );
                          this.manager.addAmbient(
                            colData[ap].x + ar * Math.sin(a4),
                            colData[ap].y + ar * Math.cos(a4),
                            at.z,
                            Math.PI / 2,
                            a4,
                            -Math.PI / 2,
                            at.length,
                            at.width,
                            0,
                            [OBJECT, U],
                            "g5-" + as + "-" + ap,
                            [colData[ap].x, colData[ap].y, aq.z + aq.length],
                          );
                          at = UTILS.limitRect(
                            colData[ap].z + ar * Math.sin(a4),
                            aq.z - aq.length - ar - config.ambOff,
                            ar,
                            ar,
                            Math.PI / 2,
                            [OBJECT, U],
                            "x",
                            "z",
                          );
                          this.manager.addAmbient(
                            colData[ap].x + ar * Math.sin(a4),
                            colData[ap].y + ar * Math.cos(a4),
                            at.z,
                            Math.PI / 2,
                            a4,
                            Math.PI,
                            at.width,
                            at.length,
                            0,
                            [OBJECT, U],
                            "g6-" + as + "-" + ap,
                            [colData[ap].x, colData[ap].y, aq.z - aq.length],
                          );
                        } else {
                          at = UTILS.limitRect(
                            colData[ap].x + ar * Math.sin(a4),
                            aq.z + aq.length + ar + config.ambOff,
                            ar,
                            ar,
                            Math.PI / 2,
                            [OBJECT, U],
                            "x",
                            "z",
                          );
                          this.manager.addAmbient(
                            at.x,
                            colData[ap].y + ar * Math.cos(a4),
                            at.z,
                            Math.PI / 2,
                            a4,
                            -Math.PI / 2,
                            at.length,
                            at.width,
                            0,
                            [OBJECT, U],
                            "g5-" + as + "-" + ap,
                            [colData[ap].x, colData[ap].y, aq.z + aq.length],
                          );
                          at = UTILS.limitRect(
                            colData[ap].x + ar * Math.sin(a4),
                            aq.z - aq.length - ar - config.ambOff,
                            ar,
                            ar,
                            Math.PI / 2,
                            [OBJECT, U],
                            "x",
                            "z",
                          );
                          this.manager.addAmbient(
                            at.x,
                            colData[ap].y + ar * Math.cos(a4),
                            at.z,
                            Math.PI / 2,
                            a4,
                            Math.PI,
                            at.width,
                            at.length,
                            0,
                            [OBJECT, U],
                            "g6-" + as + "-" + ap,
                            [colData[ap].x, colData[ap].y, aq.z - aq.length],
                          );
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        this.manager.addPendingAOs();
      }
      this.manager.genQuads();
      this.spawns.length = 0;
      for (i = 0; i < mapData.spawns.length; ++i) {
        this.spawns.push({
          x: mapData.spawns[i][0],
          y: mapData.spawns[i][1],
          z: mapData.spawns[i][2],
          team: mapData.spawns[i][3],
          dir: parseInt(mapData.spawns[i][4]) || 0,
          comp: !!mapData.spawns[i][5],
        });
      }
      if (RENDER) {
        RENDER.addMeshGroups();
      }
      if (RENDER) {
        RENDER.finalizeInstanceGroups();
      }
    }
    this.finishGenerate();
  };
  this.finishGenerate = function () {};
};
